import { WSSelect } from "@wingspanhq/fe-component-library";
import React, { useMemo } from "react";
import { TAX_FILING_1099_FILING_PATH } from "../../paths";
import { generatePath, useHistory, useLocation } from "react-router-dom";
import { useFocusedFeatures } from "../../../../FocusedFeatures";
import { useQueryActivities } from "../../../../query/users/queries";
import { useUserId } from "../../../../query/hooks/helpers";
import { get1099SetupProgress } from "../../../../query/users/selectors";
import {
  getTaxYears,
  OLD_TAX_YEAR
} from "../../../../shared/constants/taxYear";
import { useQueryFeatureFlags } from "@hooks/useQueryFeatureFlags";

type Props = {};

export const SelectTaxYear: React.FC<Props> = ({}) => {
  const userId = useUserId();
  const location = useLocation();
  const history = useHistory();
  const focusedFeatures = useFocusedFeatures();
  const featureFlagsQuery = useQueryFeatureFlags();
  const queryActivity = useQueryActivities(userId);

  const nec1099Setup = get1099SetupProgress(queryActivity.data);

  const options = useMemo(() => {
    return [
      ...getTaxYears().map(year => ({
        value: `${year}`,
        label: `${year}`,
        path: generatePath(TAX_FILING_1099_FILING_PATH, { year })
      })),
      {
        value: `${OLD_TAX_YEAR}`,
        label: `${OLD_TAX_YEAR}`,
        path: "/member/1099-filing"
      }
    ].filter(p =>
      focusedFeatures.showTaxFilingYearSwitcher && nec1099Setup?.complete
        ? true
        : p.value !== `${OLD_TAX_YEAR}`
    );
  }, [
    focusedFeatures.showTaxFilingYearSwitcher,
    nec1099Setup?.complete,
    featureFlagsQuery.data?.taxFilingSeason2025
  ]);

  const currentOption = options.find(p => location.pathname.startsWith(p.path));

  const defaultValue = currentOption?.value || options[0].value;

  return (
    <WSSelect
      hideClearAction={true}
      mode="single"
      disabled={!queryActivity.data}
      value={defaultValue}
      onChange={newValue => {
        const newOption = options.find(p => p.value === newValue)!;

        history.push(newOption.path);
      }}
      options={options}
    />
  );
};
